import { Link } from "react-router-dom";

import { useSelector } from "react-redux";
import logo from "../../../../assets/images/logo/logo.svg";
import logoDark from "../../../../assets/images/logo/logo-dark.svg";

export default function MenuLogo(props) {
  const customise = useSelector((state) => state.customise);

  const handleLogout = (event) => {
    props.handleLinkClick(event, "/");
    props.onClose();
  };

  return (
    <div className="hp-header-logo hp-d-flex hp-align-items-center">
      <Link
        to="/"
        onClick={(e) => handleLogout(e)}
        className="hp-position-relative hp-d-flex"
      >
        {props.small ? (
          customise.theme == "light" ? (
            <img className="hp-logo" src={logo} alt="logo" />
          ) : (
            <img className="hp-logo" src={logoDark} alt="logo" />
          )
        ) : customise.direction == "rtl" ? (
          customise.theme == "light" ? (
            <img className="hp-logo" src={logo} alt="logo" />
          ) : (
            <img className="hp-logo" src={logoDark} alt="logo" />
          )
        ) : customise.theme == "light" ? (
          <img className="hp-logo" src={logo} alt="logo" />
        ) : (
          <img className="hp-logo" src={logoDark} alt="logo" />
        )}
      </Link>
    </div>
  );
}
